/* global dataLayer */

export default {
  handle(event, obj) {
    if (typeof dataLayer === 'undefined') {
      return;
    }

    dataLayer.push({
      event,
      ...obj,
    });
  },

  productClick(obj, list, cb) {
    this.handle('productClick', {
      ecommerce: {
        click: {
          actionField: { list },
          products: [
            obj,
          ],
        },
      },
      eventCallback: typeof cb !== 'undefined' ? cb : () => {},
    });
  },

  addProduct(obj, cb) {
    const arr = Array.isArray(obj) ? obj : [obj];

    this.handle('addToCart', {
      ecommerce: {
        add: {
          products: arr,
        },
      },
      eventCallback: typeof cb !== 'undefined' ? cb : () => {},
    });
  },

  removeProduct(obj, cb) {
    this.handle('removeFromCart', {
      ecommerce: {
        remove: {
          products: [
            obj,
          ],
        },
      },
      eventCallback: typeof cb !== 'undefined' ? cb : () => {},
    });
  },

  // checkoutOption(option, currentStep) {
  //   dataLayer.push({
  //     event: 'checkoutOption',
  //     ecommerce: {
  //       checkout_option: {
  //         actionField: {
  //           step: currentStep,
  //           option,
  //         },
  //       },
  //     },
  //   });
  // },

  event(category, action = '(not set)', label = '(not set)', value = '(not set)') {
    this.handle('general_event', {
      general_event_category: category,
      general_event_action: action,
      general_event_label: label,
      general_event_value: value,
    });
  },

  timing(naming, value) {
    this.handle('timing', {
      timing_name: naming,
      timing_value: value,
    });
  },
};
